/**
 * Create Categories context for custom hook
 */
import { createContext } from 'react'

const CategoriesContext = createContext({
  fetchCategories: () => {},
  fetchCategoriesAll: () => {},
  fetchCategoryByCode: () => {},
})

export default CategoriesContext
